import { Container } from 'react-bootstrap';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';
import { stopVideo } from '../../../utils/utils';
import VideoEmbedModal from './VideoEmbedModal';

const VideoEmbedModalDemo = () => {
  const [
    showVideoEmbedModal,
    handleShowVideoEmbedModal,
    handleCloseVideoEmbedModal,
  ] = useModal();

  return (
    <Container>
      <h4>Video Embed Modal</h4>
      <Button onClick={handleShowVideoEmbedModal}>Video Embed Modal</Button>
      <VideoEmbedModal
        showVideoEmbedModal={showVideoEmbedModal}
        handleCloseVideoEmbedModal={handleCloseVideoEmbedModal}
        stopVideo={stopVideo}
        embeddedNode={
          <div className={'d-flex justify-content-center'}>
            <iframe
              src={
                'https://app.rollovercentral.com/Video/Video?eqs=FMuPQAOqIkWGGBNrmnatuA%3D%3D'
              }
              title={'rollover'}
              width={620}
              height={450}
            ></iframe>
          </div>
        }
      />
    </Container>
  );
};

export default VideoEmbedModalDemo;
